import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductUpdateService {
  private productUpdateSubject = new Subject<void>();

  // Observable that components can subscribe to
  get productUpdate$() {
    return this.productUpdateSubject.asObservable();
  }

  // Method to trigger product updates
  notifyProductUpdate(): void {
    this.productUpdateSubject.next();
  }
}
